import { render, staticRenderFns } from "./ProviderAssociatedResourceTabs.vue?vue&type=template&id=43a8430c&scoped=true&"
import script from "./ProviderAssociatedResourceTabs.vue?vue&type=script&lang=js&"
export * from "./ProviderAssociatedResourceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a8430c",
  null
  
)

export default component.exports